/**
 * External dependencies
 */
import { Reducer } from 'redux';

/**
 * Internal dependencies
 */
import { setUser } from '../../actions';
import { UserModel } from '@/user';
import initialState from '../../initialState';
import isAction from '../../isAction';

const user: Reducer<UserModel | null> = (
	state = initialState.auth.user,
	action
) => (isAction(action, setUser) ? action.payload : state);

export default user;
